<div class="p-component">
  <router-outlet></router-outlet>
</div>
